import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

// STYLES
import { ChannelSkeleton } from './styles';

const ChannelsListSkeleton = ({ containerProps, itemProps, chanelProps }) => {
  const data = new Array(24).fill().map((_, i) => (
    <Grid item xs={3} sm={2} md={2} key={i} {...itemProps}>
      <ChannelSkeleton {...chanelProps} />
    </Grid>
  ));

  return (
    <Grid container spacing={1} {...containerProps}>
      {data}
    </Grid>
  );
};

ChannelsListSkeleton.defaultProps = {
  containerProps: {},
  itemProps: {},
  chanelProps: {},
};

ChannelsListSkeleton.propTypes = {
  containerProps: PropTypes.object,
  itemProps: PropTypes.object,
  chanelProps: PropTypes.object,
};

export default React.memo(ChannelsListSkeleton);
